import type { IconProps } from './types';

export const HeartFilledIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M8.88075 3.88075L9.99992 5L11.1193 3.88065C12.0033 2.99663 13.2023 2.5 14.4526 2.5C17.0561 2.5 19.1666 4.61061 19.1666 7.21412C19.1666 8.46433 18.6699 9.66333 17.7859 10.5473L9.99992 18.3333L2.21403 10.5474C1.32998 9.66333 0.833333 8.46425 0.833333 7.21404C0.833333 4.61056 2.94387 2.5 5.54735 2.5C6.79761 2.5 7.99666 2.99667 8.88075 3.88075Z"
        fill={color}
      />
    </svg>
  );
};
